import { createElementBlock as l, openBlock as n, createElementVNode as o } from "vue";
const t = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function r(v, e) {
  return n(), l("svg", t, e[0] || (e[0] = [
    o("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.196 10.838 6.38 14h2.723l-3.006-3.757 2.98-3.784h-2.71l-2.17 3.068V4H2v10h2.196zM21.204 7.23q-.784-.852-2.12-.852-.757 0-1.4.392-.642.393-1.014 1.014a2.54 2.54 0 0 0-1.002-1.04q-.63-.366-1.438-.366-.681 0-1.22.284-.54.27-.874.743V6.46H9.94V14h2.196V9.905q0-.73.36-1.121.372-.405 1.014-.406.642 0 1.002.406.372.392.372 1.121V14h2.184V9.905q0-.73.36-1.121.372-.405 1.014-.406.642 0 1.002.406.373.392.373 1.121V14H22V9.595q0-1.515-.796-2.365M4 17a1 1 0 1 0-2 0v2a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-2a1 1 0 1 0-2 0v1h-2.5v-1a1 1 0 1 0-2 0v1H13v-1a1 1 0 1 0-2 0v1H8.5v-1a1 1 0 1 0-2 0v1H4z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const d = { render: r };
export {
  d as default,
  r as render
};
//# sourceMappingURL=ic_distance_km-Dc7OzLPn.js.map
